import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const QuestionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Question",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M18 27.82c0 1.2-.98 2.18-2.18 2.18s-2.18-.98-2.18-2.18.98-2.18 2.18-2.18 2.18.98 2.18 2.18m-2.18-4.77c-1.2 0-2.18-.98-2.18-2.18V17.6c0-1.2.98-2.18 2.18-2.18 2.5 0 4.53-2.03 4.53-4.53s-2.03-4.53-4.53-4.53c-1.99 0-3.67 1.28-4.29 3.05v.03c-.31.87-1.12 1.48-2.08 1.48-1.2 0-2.18-.98-2.18-2.18 0-.25.04-.49.12-.71v.02c1.22-3.54 4.53-6.04 8.42-6.04a8.89 8.89 0 0 1 8.89 8.89c0 4.14-2.82 7.61-6.65 8.61h-.06v1.38c0 1.2-.98 2.17-2.18 2.17Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "15.69",
        cy: "24.71",
        r: ".57"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.69 26.42a1.71 1.71 0 1 1-.002-3.418 1.71 1.71 0 0 1 .002 3.418m0-2.28a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14M15.69 20.92c-.63 0-1.14-.51-1.14-1.14 0-2.61 1.81-4.04 3.27-5.19 1.5-1.19 2.42-1.99 2.42-3.45 0-1.76-1.86-2.99-4.53-2.99-2.16 0-4.1 1.2-4.61 2.85-.19.6-.82.94-1.43.75-.6-.19-.94-.83-.75-1.43.81-2.63 3.61-4.46 6.8-4.46 4.01 0 6.82 2.17 6.82 5.28 0 2.64-1.82 4.08-3.29 5.24-1.49 1.18-2.4 1.97-2.4 3.4 0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};